import styled from 'styled-components';

import { ToggleMenu } from '@hero/components/molecules';

const MessageExperienceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${ToggleMenu.S.ToggleMenuContent} {
    background: var(--color-bg-default);
    border: 1px solid var(--color-bg-weakest);
    border-bottom: none;
    border-top: none;
    overflow: overlay;
  }
`;

const ToggleMenuTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const GreetingCardRow = styled.div`
  display: flex;
  gap: 16px;
  margin-left: 22px;
  margin-top: 8px;
`;

const Required = styled.span`
  color: var(--color-error-default);
`;

export { GreetingCardRow, MessageExperienceWrapper, Required, ToggleMenuTitleWrapper };
